module.exports = __webpack_public_path__ + "img/op_img-header.ba11295.png";